<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Descrição" v-model="categoria.descricao" outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'
// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'Categoria',
    mixins: [metodos],
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            categoria: {},
        }
    },

    methods:{
        salvar(){
            const url = `${baseApiUrl}/Cadastros/categorias/insert.php`
				
					if(this.categoria.descricao){

						axios.post(url, this.categoria)
						.then(res => {
							if(res.data.codigo == '01'){
                                showSuccess(res.data.mensagem)
                                this.categoria.id = res.data.id_categoria
                                this.mostrar = false
                                Br.setCategoriaCadastrada(this.categoria)
							}else{
								showError(res.data.mensagem)
							}
							
						})	
					}else{
						
						showError("Todos os campos devem ser preenchidossss!")
					}	
        },

        fechar(){
            this.mostrar = false
        }
    },

    created(){
    
        Br.onNovaCategoria(()=>{
            this.categoria = {}
            this.mostrar = true
        })
    },
}
</script>

<style scoped>

</style>